import { FunctionComponent } from 'react';

type LoadingProps = {
  colour?: 'blue' | 'white';
};

export const LoadingSpinner: FunctionComponent<LoadingProps> = ({
  colour = 'blue',
}: LoadingProps): JSX.Element => (
  <svg
    className="animate-spin"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      className={`cursor-default !fill-none stroke-[4px] opacity-25 ${
        colour === 'white' ? '!stroke-white' : '!stroke-blue'
      }`}
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className={`stroke-none opacity-75 ${
        colour === 'white' ? 'fill-white' : 'fill-blue'
      }`}
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      fill="currentColor"
    />
  </svg>
);
